const local = {
  apiGateway: {
    URL: "https://api.memberpoint.io",
    // URL: "http://157.230.27.147",
  },
  mediaGateway: {
    // URL: "https://api.memberpoint.io",
    URL: "http://157.230.27.147",
  },
  stripe: {
    key: "pk_test_Osu2iYG3m8zmTD1xI1vljmJN00jDeQAy6a",
  },
};

const staging = {
  apiGateway: {
    URL: "https://be-staging.memberpoint.io",
  },
  mediaGateway: {
    URL: "https://be-staging.memberpoint.io",
  },
  stripe: {
    key: "pk_test_Osu2iYG3m8zmTD1xI1vljmJN00jDeQAy6a",
    //key: process.env.STRIPE_STAGING_PUBLISHABLE_KEY
  },
};

const production = {
  apiGateway: {
    URL: "https://api.memberpoint.io",
  },
  mediaGateway: {
    URL: "https://api.memberpoint.io",
  },
  stripe: {
    key: "pk_live_51MRf2VIyg9fp9h1VTO6swfpD70rFZCsZ3uutAFuNfAb10pnU03E1AketTYj9oBa6b1zeJ9NRBkC110RG6jHEF0PW00Gc3aOrrXa",
  },
};

const config =
  process.env.REACT_APP_DEPLOYMENT === "production"
    ? production
    : process.env.REACT_APP_DEPLOYMENT === "staging"
      ? staging
      : local;

export default {
  someCommonConfig: "",
  ...config,
};
